import { useTranslation } from '../../../i18n/useTranslation';

interface Props {
  selectedCount: number;
  onDelete: () => void;
  onStatus: () => void;
  onQuotas: () => void;
  onExport: () => void;
  onClearSelection: () => void;
  onSelectAllFilter: () => void;
  busy: boolean;
}

export function BookBulkActionsBar({
  selectedCount,
  onDelete, onStatus, onQuotas, onExport,
  onClearSelection, onSelectAllFilter,
  busy,
}: Props) {
  const { t } = useTranslation();

  if (selectedCount === 0) {
    return (
      <div className="flex items-center justify-between border-b border-neutral-200 py-2">
        <button
          type="button" onClick={onSelectAllFilter}
          className="text-sm text-primary-600 hover:underline min-h-[36px]"
        >
          {t('App.Admin.Books.BookBulkActionsBar.SelectAllFilter')}
        </button>
        <button
          type="button" onClick={onExport} disabled={busy}
          className="px-3 py-1 border rounded text-sm min-h-[36px] disabled:opacity-50"
        >
          {t('App.Admin.Books.BookBulkActionsBar.ExportToExcel')}
        </button>
      </div>
    );
  }

  return (
    <div
      className="flex flex-wrap items-center justify-between gap-2 bg-primary-50 border border-primary-200 rounded px-3 py-2 sticky top-0 z-10"
      role="toolbar" aria-label={t('App.Admin.Books.BookBulkActionsBar.AriaLabel')}
    >
      <span className="text-sm">
        {t('App.Admin.Books.BookBulkActionsBar.SelectedCount', { count: selectedCount })}
      </span>
      <div className="flex flex-wrap gap-2">
        <button type="button" onClick={onStatus}  disabled={busy} className="px-3 py-1 border rounded text-sm min-h-[44px] disabled:opacity-50">{t('App.Admin.Books.BookBulkActionsBar.ChangeStatus')}</button>
        <button type="button" onClick={onQuotas}  disabled={busy} className="px-3 py-1 border rounded text-sm min-h-[44px] disabled:opacity-50">{t('App.Admin.Books.BookBulkActionsBar.UpdateQuotas')}</button>
        <button type="button" onClick={onExport}  disabled={busy} className="px-3 py-1 border rounded text-sm min-h-[44px] disabled:opacity-50">{t('App.Admin.Books.BookBulkActionsBar.Export')}</button>
        <button type="button" onClick={onDelete}  disabled={busy} className="px-3 py-1 bg-red-600 text-white rounded text-sm min-h-[44px] disabled:opacity-50">{t('App.Admin.Books.BookBulkActionsBar.Delete')}</button>
        <button type="button" onClick={onClearSelection} className="px-3 py-1 border rounded text-sm min-h-[44px]">{t('App.Admin.Books.BookBulkActionsBar.Clear')}</button>
      </div>
    </div>
  );
}
